


import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import './combos.css';
// Helper: Format image source from base64 or fallback
const getValidImage = (image) => {
    if (!image) return "https://via.placeholder.com/120";

    const cleanImage = image.replace(/\s/g, '');

    if (cleanImage.startsWith("data:image")) {
        return cleanImage;
    } else {
        return `data:image/jpeg;base64,${cleanImage}`;
    }
};

// Individual Team Card
const LeadershipCardItem = ({ name, title, image, description }) => (
    <div style={cardStyle}>
        <img
            src={getValidImage(image)}
            alt={name || "Team Member"}
            style={imageStyle}
        />
        <h3 style={nameStyle}>{name || "Unnamed"}</h3>
        <p style={titleStyle}>{title || "No Title"}</p>
        <p style={descStyle}>{description || "No Description Available"}</p>
    </div>
);

// Main Component
const LeadershipCard = () => {


    const [vendorId, setVendorId] = useState(null);
    const [teamData, setTeamData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    /* 1️⃣ read vendorId once */
    useEffect(() => {
        setVendorId(localStorage.getItem("vendorId"));      // string or null
    }, []);

    /* 2️⃣ fetch team list when vendorId is ready */
    useEffect(() => {
        if (!vendorId) return; // not ready yet

        setLoading(true);
        setError(null);

        const token = localStorage.getItem("authToken"); // ✅ get stored token

        fetch(
            ` https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ send token in headers
                    Accept: "application/json",
                },
            }
        )
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((data) => {
                // API might return an array directly or wrap it in { data: [...] }
                const teamArray = Array.isArray(data) ? data : data.data;
                if (!Array.isArray(teamArray)) {
                    throw new Error("Unexpected API format");
                }
                setTeamData(teamArray);
            })
            .catch((err) => {
                console.error("❌ Error fetching team data:", err);
                setError("Failed to load team data");
            })
            .finally(() => setLoading(false));
    }, [vendorId]);


    return (
        <section style={sectionStyle} className="leadership-data-cards">
            <h1 style={headerTextStyle}>OUR TEAM</h1>

            {loading && <p style={{ textAlign: "center" }}>Loading team members...</p>}
            {error && <p style={{ textAlign: "center", color: "red" }}>{error}</p>}

            {!loading && !error && (
                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 }
                    }}
                >
                    {teamData.map((member) => (
                        <SwiperSlide key={member.teamId}>
                            <LeadershipCardItem
                                name={member.name}
                                title={member.designation}
                                image={member.image}
                                description={member.description}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}

            <br /><br />
        </section>
    );
};

// --- Inline Styles ---
const sectionStyle = {
    // maxWidth: "1310px",
    margin: "0 auto",
    // border: "2px solid rgb(177 93 198)",
    borderRadius: "10px",
    padding: "20px",
    backgroundColor: 'rgb(177 93 198)',
};

const headerTextStyle = {
    fontSize: "32px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "28px",
    marginTop: "10px",
    color: "rgb(255 225 36)",
    fontFamily: 'revert'
};
const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "30px 20px",
    textAlign: "center",
    transition: "0.3s ease-in-out",
    width: "100%",
    maxWidth: "400px",
    // border: "1px solid #ee6521",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
};

const imageStyle = {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: "20px",
    border: "4px solid #2a0947",
};

const nameStyle = {
    fontSize: "22px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    textAlign: "center",
    wordWrap: "break-word",
    overflowWrap: "break-word",
};

const titleStyle = {
    fontSize: "16px",
    fontWeight: "500",
    color: "#ee6521",
    marginBottom: "12px",
    textAlign: "center",
    wordWrap: "break-word",
    overflowWrap: "break-word",
};

const descStyle = {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.5",
    textAlign: "center",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    maxWidth: "100%",
};


export default LeadershipCard;
